import * as React from "react";
import { FormGroup, InputGroup, Intent, NumericInput, SelectMenu, ColorPicker, CustomLabel, } from "@focus/focusUI";
import { AxisType, AxisMode } from "../interfaces/axis";
import { produce } from "immer";
import { GrafosDialogInput } from "./GrafosDialogInput";
export class GrafosAxisDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.axes = Object.keys(AxisType);
        this.modes = Object.keys(AxisMode);
        this.setSelectedAxis = (axisType) => {
            this.setState({
                selectedAxis: axisType,
            });
        };
        this.state = {
            selectedAxis: props.content[0].type,
        };
    }
    render() {
        const { content, onUpdate } = this.props;
        const updatefield = (fieldName) => (event) => {
            const value = (event === null || event === void 0 ? void 0 : event.target) ? event.target.value : event;
            const updatedContent = produce(content, (draft) => {
                const currentAxis = draft.find((axis) => axis.type === this.state.selectedAxis);
                currentAxis[fieldName] = value;
            });
            onUpdate(updatedContent);
        };
        const updateColor = (color) => {
            const updatedContent = produce(content, (draft) => {
                const currentAxis = draft.find((axis) => axis.type === this.state.selectedAxis);
                currentAxis.color = color.hex;
            });
            onUpdate(updatedContent);
        };
        const axis = content.find((axis) => axis.type === this.state.selectedAxis);
        const axisOptions = this.props.content.length > 2
            ? this.axes
            : this.axes.filter((axis) => axis !== "z");
        return (React.createElement(FormGroup, null,
            React.createElement(CustomLabel, { text: "Axis" },
                React.createElement(SelectMenu, { options: axisOptions, onChange: this.setSelectedAxis, value: this.state.selectedAxis })),
            React.createElement(CustomLabel, { text: "Title" },
                React.createElement(InputGroup, { intent: Intent.PRIMARY, onChange: updatefield("title"), value: axis.title })),
            React.createElement(CustomLabel, { text: "max Value" },
                React.createElement(GrafosDialogInput, { axis: axis, onChange: updatefield("maxValue"), value: axis.maxValue })),
            React.createElement(CustomLabel, { text: "min Value" },
                React.createElement(GrafosDialogInput, { axis: axis, onChange: updatefield("minValue"), value: axis.minValue })),
            React.createElement(CustomLabel, { text: "width" },
                React.createElement(NumericInput, { intent: Intent.PRIMARY, onValueChange: updatefield("width"), value: axis.width })),
            React.createElement(CustomLabel, { text: "mode" },
                React.createElement(SelectMenu, { options: this.modes, onChange: updatefield("mode"), value: axis.mode })),
            React.createElement(CustomLabel, { text: "color" },
                React.createElement(ColorPicker, { onChange: updateColor, color: axis.color ? axis.color : "black" }))));
    }
}
//# sourceMappingURL=GrafosAxisDialog.js.map